function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoDataFound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 151,
    viewBox: "0 0 140 151",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17667"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "10. Research"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2476",
    cx: 69.584,
    cy: 69.605,
    rx: 69.584,
    ry: 69.605,
    style: {
      fill: "#d2f5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51005",
    d: "M32 74h11.244v8.433H32z",
    transform: "translate(5.972 28.033)",
    style: {
      fill: "#8fa2ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51006",
    d: "M127.467 65.327a70.161 70.161 0 0 1-11.806 45.3H54.622A5.622 5.622 0 0 1 49 105V1.5c39.227-4.717 75.221 24.418 78.467 63.827z",
    transform: "translate(12.279 -.999)",
    style: {
      fill: "#bebeff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17666"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51007",
    d: "M105.743 22.811H72.405a1.405 1.405 0 1 1 0-2.811h31.215a49.99 49.99 0 0 1 2.123 2.811z",
    transform: "translate(21.199 6.436)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51008",
    d: "M116.63 27.811H56.405a1.405 1.405 0 0 1 0-2.811h58.608a55.33 55.33 0 0 1 1.617 2.811z",
    transform: "translate(14.711 8.463)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51009",
    d: "M119.652 31.831a1.405 1.405 0 0 1-1.405.984H56.405a1.405 1.405 0 0 1 0-2.811c66.338 0 62-.07 62.417.126.267.562.52 1.124.83 1.701z",
    transform: "translate(14.711 10.487)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51010",
    d: "M118.246 37.811H56.405a1.405 1.405 0 1 1 0-2.811h61.841a1.405 1.405 0 0 1 0 2.811z",
    transform: "translate(14.711 12.518)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51011",
    d: "M118.246 42.811H56.405a1.405 1.405 0 0 1 0-2.811h61.841a1.405 1.405 0 0 1 0 2.811z",
    transform: "translate(14.711 14.545)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51012",
    d: "M118.246 47.811H56.405a1.405 1.405 0 1 1 0-2.811h61.841a1.405 1.405 0 0 1 0 2.811z",
    transform: "translate(14.711 16.573)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51013",
    d: "M118.246 52.811H56.405a1.405 1.405 0 1 1 0-2.811h61.841a1.405 1.405 0 0 1 0 2.811z",
    transform: "translate(14.711 18.6)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51014",
    d: "M118.246 57.811H56.405a1.405 1.405 0 0 1 0-2.811h61.841a1.405 1.405 0 0 1 0 2.811z",
    transform: "translate(14.711 20.627)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51015",
    d: "M118.246 62.811H56.405a1.405 1.405 0 0 1 0-2.811h61.841a1.405 1.405 0 0 1 0 2.811z",
    transform: "translate(14.711 22.655)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51016",
    d: "M118.246 67.811H56.405a1.405 1.405 0 1 1 0-2.811h61.841a1.405 1.405 0 0 1 0 2.811z",
    transform: "translate(14.711 24.682)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51017",
    d: "M80.3 72.811H56.405a1.405 1.405 0 0 1 0-2.811H80.3a1.405 1.405 0 0 1 0 2.811z",
    transform: "translate(14.711 26.709)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2481",
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    transform: "translate(8 34.658)",
    style: {
      fill: "#6868f9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2482",
    cx: 27,
    cy: 26,
    rx: 27,
    ry: 26,
    transform: "translate(17 43.651)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3932",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(32.773 111.401)",
    style: {
      fill: "#4394ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51018",
    d: "M38.027 119.137A7.027 7.027 0 0 1 31 112.109V84h14.055v28.109a7.027 7.027 0 0 1-7.027 7.027z",
    transform: "translate(5.57 31.863)",
    style: {
      fill: "#6868f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51019",
    d: "M105.161 20.055H55V6h30.653a70.006 70.006 0 0 1 19.508 14.055z",
    transform: "translate(14.711 1.027)",
    style: {
      fill: "#4e6aff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2484",
    cx: 3,
    cy: 2.5,
    rx: 3,
    ry: 2.5,
    transform: "translate(40.747 142.209)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.239 0a22.239 22.239 0 1 0 22.238 22.239A22.263 22.263 0 0 0 22.239 0zm0 35.211a1.853 1.853 0 1 1 1.853-1.853 1.854 1.854 0 0 1-1.853 1.853zm2.934-11.783a1.861 1.861 0 0 0-1.08 1.685v.832a1.853 1.853 0 1 1-3.706 0v-.832a5.583 5.583 0 0 1 3.234-5.052 6.057 6.057 0 0 0 3.252-4.309 4.633 4.633 0 0 0-9.266 0 1.853 1.853 0 1 1-3.707 0 8.339 8.339 0 0 1 16.679 0c-.001 2.504-2.173 6.185-5.407 7.676zm0 0",
    transform: "translate(21.227 47.82)",
    style: {
      fill: "#00c99f"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoDataFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/noDataFound.1c5ab6fa8ae1956839f1a12035424aa2.svg";